/* eslint-disable */
import { useState, useEffect } from "react";

// ── LOGO — viewBox fijo coordenadas exactas v19 ──────────────
const GestiaLogo = ({ height = 52, dark = false }) => {
  const vw = 340, vh = 110, s = 68;
  const uid = `L${height}${dark}`;
  const lift = s*.08, gX = s*.38;
  const bX = s*.38, bY = s*.65-lift, bW = s*.38, bH = s*.22;
  const tk = s*.068, txB = s*.72, tyB = s*.91, tG = s*.052, sw = s*.02;
  return (
    <svg width={height*(vw/vh)} height={height} viewBox={`0 0 ${vw} ${vh}`}>
      <defs>
        <linearGradient id={`g-${uid}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#059669"/><stop offset="100%" stopColor="#065F46"/>
        </linearGradient>
      </defs>
      <g transform="translate(8,14)">
        <rect x="0" y="0" width={s} height={s} rx={s*.265} fill={`url(#g-${uid})`}/>
        <path d={`M 0 ${s*.78} Q -3 ${s*1.05} ${s*.22} ${s*1.08} Q ${s*.12} ${s*.95} ${s*.18} ${s*.82} Z`} fill={`url(#g-${uid})`}/>
        <text x={gX} y={s*.71-lift} fontFamily="Georgia,serif" fontSize={s*.52} fontWeight="700" fill="white" textAnchor="middle">G</text>
        <rect x={bX} y={bY} width={bW} height={bH} rx="4" fill="rgba(255,255,255,.25)"/>
        <text x={bX+bW/2} y={bY+bH*.75} fontFamily="'Courier New',monospace" fontSize={s*.13} fill="white" textAnchor="middle" fontWeight="700" letterSpacing=".3">IA</text>
        <path d={`M ${txB} ${tyB} L ${txB+tk*.4} ${tyB+tk*.5} L ${txB+tk} ${tyB-tk*.4}`} stroke="white" strokeWidth={sw} fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        <path d={`M ${txB+tG} ${tyB} L ${txB+tG+tk*.4} ${tyB+tk*.5} L ${txB+tG+tk} ${tyB-tk*.4}`} stroke="white" strokeWidth={sw} fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <text x="88" y="66" fontFamily="'Palatino Linotype','Book Antiqua',Georgia,serif" fontSize="50" fontWeight="300" letterSpacing="-2" fill={dark?"#F1F5F9":"#111827"}>Gest</text>
      <rect x="189" y="22" width="1.5" height="46" rx="1" fill={dark?"#4B5563":"#B0B8C4"}/>
      <text x="196" y="66" fontFamily="'Palatino Linotype','Book Antiqua',Georgia,serif" fontSize="50" fontWeight="700" letterSpacing="-2" fill="#4338CA">IA</text>
      <text x="88" y="88" fontFamily="'Courier New',monospace" fontSize="9.5" fill={dark?"#6B7280":"#374151"} letterSpacing="1.5">Más tiempo para tus clientes</text>
    </svg>
  );
};

// ── COLORES ──────────────────────────────────────────────────
const IND="#4338CA", GRN="#059669", DRK="#111827", MUT="#6B7280", BRD="#E5E7EB", LGT="#F9FAFB";

// ── DATA ─────────────────────────────────────────────────────
// eslint-disable-next-line no-unused-vars
const PLANS = [
  { n:"Gratis", p:0, sub:"1 cliente", c:"#6B7280", hi:false },
  { n:"Starter", p:56000, sub:"Hasta 10 clientes", c:GRN, hi:false },
  { n:"Estudio", p:105000, sub:"Hasta 30 clientes", c:IND, hi:true },
  { n:"Pro", p:182000, sub:"+ 30 clientes", c:GRN, hi:false },
];

const FEATS = [
  {e:"💬",t:"Agente WhatsApp 24/7",d:"Tus clientes escriben y reciben respuestas inmediatas con datos reales de ARCA. Sin que vos intervengas."},
  {e:"📅",t:"Recordatorios proactivos",d:"Avisa 7 días, 1 día y el mismo día del vencimiento con el monto exacto del VEP, al contador y directo a los clientes."},
  {e:"✅",t:"Seguimiento post-vencimiento",d:"Verifica en ARCA si el pago fue acreditado. Si no, gestiona la consulta directamente al cliente."},
  {e:"💳",t:"Cobro de honorarios",d:"Recordatorios automáticos con monto y datos de transferencia. Sin que vos tengas que reclamarlo."},
  {e:"📊",t:"Reporte diario al contador",d:"Cada mañana podés recibir por WhatsApp qué vence ese día, quién debe y quién pagó honorarios."},
  {e:"📄",t:"Facturas → Excel/CSV",d:"El cliente manda fotos o archivos, y el agente las convierte en Excel cruzado contra ARCA."},
  {e:"🔍",t:"Comparativa vs ARCA",d:"Detecta que todas las facturas enviadas por el cliente estén en ARCA. Si no están, las pone en un Excel y se lo envía al contador."},
  {e:"📰",t:"Novedades normativas",d:"Scraping del Boletín Oficial. Te avisa qué cambió y qué clientes se ven afectados."},
  {e:"📈",t:"IA de Salud Financiera",d:"Alerta al contador cuando un cliente tiene algún desbalance en sus ingresos y gastos o patrón de importancia, para que el contador pueda darle el mejor servicio a todos sus clientes."},
  {e:"👁️",t:"Visibilidad total en vivo",d:"Tenés acceso completo a todo lo que el asistente envía y a lo que responden tus clientes, en tiempo real. Control total, siempre."},
];

const FAQS = [
  {q:"¿Cómo se conecta a ARCA?", a:"Se conecta solo con las mismas credenciales que ya tenés. Podés cargar la información de tus clientes de tres formas: compartiendo un link de Google Drive, subiendo un Excel o CSV, o cargándola a mano directamente en la plataforma."},
  {q:"¿Mis clientes tienen que instalar algo?", a:"No. Tus clientes reciben mensajes en WhatsApp desde el número del asistente de tu estudio. No descargan ninguna app ni se registran en ningún lado."},
  {q:"¿Qué pasa si el asistente no sabe responder algo?", a:"Te lo deriva a vos directamente con el contexto completo de la consulta. El asistente nunca improvisa ni da información que no tenga confirmada."},
  {q:"¿Cuánto tarda en configurarse?", a:"Menos de 10 minutos. Cargás los datos de tus clientes, le ponés el nombre y foto del estudio, tildás qué funciones querés activar y listo."},
  {q:"¿Puedo elegir qué hace el asistente?", a:"Sí. Vos decidís qué activar: recordatorios de vencimientos, avisos a clientes, gestión de honorarios, conciliación de facturas, novedades normativas y más. Solo lo que necesitás."},
  {q:"¿Cuántos clientes puedo tener?", a:"Tenemos planes para cualquier tamaño de estudio. Desde 1 cliente con el plan gratuito, hasta carteras ilimitadas con el plan Pro. Si crecés, tu plan crece con vos."},
  {q:"¿Puedo probarlo gratis?", a:"¡Sí! Podés probarlo gratis para todos tus clientes durante 7 días con cualquier plan pago, o podés empezar solo con un cliente usando el plan gratuito inicial sin límite de tiempo."},
  {q:"¿Puedo ver lo que el asistente le envía a mis clientes?", a:"Sí. Tenés visibilidad total y en vivo de todo lo que el asistente envía y de lo que responden tus clientes. Control completo, en todo momento."},
  {q:"¿Qué pasa con mis datos y los de mis clientes?", a:"Los datos se almacenan de forma segura y cifrada. Nunca compartimos información con terceros. Cumplimos con las normas de protección de datos vigentes en Argentina."},
];

const PlanCard = ({p, i, annual, IND, GRN, DRK, MUT, BRD}) => {
  const [open, setOpen] = useState(false);
  const usuarios = ["1","2","3","5"][i];
  return (
    <div style={{background:"#fff",border:`2px solid ${p.hi?IND:BRD}`,borderRadius:14,padding:20,position:"relative",boxShadow:p.hi?"0 8px 32px rgba(67,56,202,.12)":"none"}}>
      {p.hi && <div style={{position:"absolute",top:-12,left:"50%",transform:"translateX(-50%)",background:IND,color:"white",fontSize:9,fontWeight:700,letterSpacing:2,padding:"3px 12px",borderRadius:20,whiteSpace:"nowrap"}}>⭐ MÁS ELEGIDO</div>}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:12}}>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:p.c,textTransform:"uppercase",letterSpacing:1.5,marginBottom:4}}>{p.n}</div>
          <div style={{fontSize:13,color:MUT}}>{p.sub}</div>
        </div>
        <div style={{textAlign:"right"}}>
          {p.p>0&&annual&&<div style={{fontSize:10,fontWeight:700,color:GRN,background:"#ECFDF5",borderRadius:20,padding:"2px 8px",display:"inline-block",marginBottom:4}}>30% OFF</div>}
          <div style={{fontSize:28,fontWeight:900,color:p.hi?IND:DRK,lineHeight:1}}>
            ${Math.round(annual&&p.p>0?p.p*.7:p.p).toLocaleString("es-AR")}
          </div>
          <div style={{fontSize:11,color:MUT}}>/mes</div>
        </div>
      </div>
      <button onClick={()=>window.open("https://somosgestia.com/registro","_blank")}
        style={{width:"100%",background:p.hi?IND:p.p===0?"#6B7280":DRK,color:"white",border:"none",borderRadius:8,padding:"11px",fontSize:14,fontWeight:700,cursor:"pointer",fontFamily:"inherit",marginBottom:10}}>
        {p.p===0?"Gratis":"Probá 7 días"}
      </button>
      <button onClick={()=>setOpen(!open)}
        style={{width:"100%",background:"transparent",border:`1px solid ${BRD}`,borderRadius:8,padding:"9px",fontSize:13,fontWeight:600,cursor:"pointer",fontFamily:"inherit",color:MUT,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
        {open?"Ocultar funcionalidades ↑":"Ver funcionalidades ↓"}
      </button>
      {open && (
        <div style={{paddingTop:12,marginTop:12,display:"flex",flexDirection:"column",gap:8}}>
          {[
            ["Clientes", p.sub],
            ["Usuarios", usuarios],
            ["WhatsApp","✓"],
            ["Calendario de vencimientos","✓"],
            ["Gestión de vencimientos","✓"],
            ["Envío de honorarios","✓"],
            ["Conciliación de facturas","✓"],
            ["Consultas ARCA","✓"],
            ["Recomendaciones IA","✓"],
            ["Soporte", p.soporte],
          ].map(([label,val])=>(
            <div key={label} style={{display:"flex",justifyContent:"space-between",fontSize:13,borderBottom:`1px solid ${BRD}`,paddingBottom:7}}>
              <span style={{color:MUT}}>{label}</span>
              <span style={{color:val==="✓"?GRN:val==="—"?"#D1D5DB":DRK,fontWeight:val==="✓"?"700":"500"}}>{val}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function App() {
  const [annual, setAnnual] = useState(true);
  const [faq, setFaq] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const [form, setForm] = useState({nombre:"",email:"",tel:"",consulta:""});
  const [sent, setSent] = useState(false);

  useEffect(()=>{
    const fn=()=>setScrolled(window.scrollY>20);
    window.addEventListener("scroll",fn);
    return ()=>window.removeEventListener("scroll",fn);
  },[]);

  const go = id => document.getElementById(id)?.scrollIntoView({behavior:"smooth"});

  return (
    <div style={{fontFamily:"'Palatino Linotype','Book Antiqua',Georgia,serif",background:"#fff",color:DRK,overflowX:"hidden"}}>
      <style>{`
        *{box-sizing:border-box;margin:0;padding:0}
        @keyframes pulse{0%,100%{opacity:.4}50%{opacity:1}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        .fu{animation:fadeUp .7s ease both}
        .cta{display:inline-flex;align-items:center;justify-content:center;gap:8px;background:${IND};color:#fff;border:none;border-radius:10px;padding:15px 34px;font-size:16px;font-weight:700;cursor:pointer;font-family:inherit;transition:all .2s;text-decoration:none}
        .cta:hover{background:#3730A3;transform:translateY(-2px);box-shadow:0 8px 24px rgba(67,56,202,.3)}
        .cta-lg{font-size:18px;padding:18px 44px;border-radius:12px}
        .cta-plan{display:block;width:100%;background:${IND};color:#fff;border:none;border-radius:8px;padding:12px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;transition:all .2s;margin-bottom:20px}
        .cta-plan:hover{opacity:.88;transform:translateY(-1px)}
        .fc{background:#fff;border:1.5px solid ${BRD};border-radius:12px;padding:22px;transition:all .2s}
        .fc:hover{border-color:${IND};box-shadow:0 4px 20px rgba(67,56,202,.08);transform:translateY(-2px)}
        .pc{background:#fff;border:2px solid ${BRD};border-radius:14px;padding:30px;transition:transform .2s;position:relative}
        .pc:hover{transform:translateY(-3px)}
        .hi{border-color:${IND}!important;box-shadow:0 16px 48px rgba(67,56,202,.12)!important}
        .fq{background:#fff;border:1.5px solid ${BRD};border-radius:10px;cursor:pointer;overflow:hidden;transition:border-color .15s}
        .fq:hover{border-color:#C7D2FE}
        .inp{padding:11px 13px;border-radius:8px;border:1.5px solid ${BRD};font-size:14px;font-family:inherit;color:${DRK};background:#fff;outline:none;width:100%;transition:all .18s}
        .inp:focus{border-color:${IND};box-shadow:0 0 0 3px rgba(67,56,202,.1)}
        ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:${IND};border-radius:2px}
        .navlink{background:none;border:none;font-family:inherit;font-size:14px;color:${MUT};cursor:pointer;padding:6px 12px;border-radius:6px;transition:all .14s;font-weight:500}
        .navlink:hover{color:${IND};background:#EEF2FF}
        .feats-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px}
        .steps-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:32px}
        .contact-grid{display:grid;grid-template-columns:1fr 1fr;gap:64px;align-items:center}
        .hero-grid{display:grid;grid-template-columns:1fr 1fr;gap:56px;align-items:center}
        .stats-bar{display:flex;justify-content:center}
        .plan-table{overflow-x:auto}
        @media(max-width:768px){
          .navlink{display:none}
          section{padding:48px 20px!important}
          nav{padding:0 16px!important;height:60px!important}
          h1{font-size:34px!important;letter-spacing:-1px!important}
          h2{font-size:26px!important}
          p{font-size:15px!important}
          .fu{animation:none}
          .feats-grid{grid-template-columns:1fr!important}
          .steps-grid{grid-template-columns:1fr!important;gap:24px!important}
          .contact-grid{grid-template-columns:1fr!important;gap:32px!important}
          .hero-grid{grid-template-columns:1fr!important;gap:32px!important}
          .cta-lg{font-size:15px!important;padding:14px 24px!important}
          .stats-bar{flex-direction:column;gap:20px;align-items:center}
          .plan-table{overflow-x:scroll;-webkit-overflow-scrolling:touch}
          table{min-width:520px;font-size:11px}
          th,td{padding:8px 5px!important}
          .footer-grid{flex-direction:column!important;gap:20px!important;text-align:center}
          .footer-links{justify-content:center!important}
        }
      `}</style>

      {/* ── NAV ── */}
      <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:"rgba(255,255,255,.97)",backdropFilter:"blur(10px)",borderBottom:`1px solid ${scrolled?BRD:"transparent"}`,padding:"0 48px",height:72,display:"flex",alignItems:"center",justifyContent:"space-between",boxShadow:scrolled?"0 2px 16px rgba(0,0,0,.06)":"none",transition:"all .3s"}}>
        <GestiaLogo height={52}/>
        <div style={{display:"flex",gap:2}}>
          {[["Precios","precios"],["Funcionalidades","feat"],["Cómo funciona","como"],["FAQ","faq"],["Contacto","contacto"]].map(([l,id])=>(
            <button key={id} className="navlink" onClick={()=>go(id)}>{l}</button>
          ))}
        </div>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <button onClick={()=>go("precios")} style={{background:"none",border:`1.5px solid ${BRD}`,borderRadius:8,padding:"9px 20px",fontSize:14,fontWeight:600,cursor:"pointer",fontFamily:"inherit",color:DRK,transition:"all .18s"}}
            onMouseEnter={e=>{e.currentTarget.style.borderColor=IND;e.currentTarget.style.color=IND}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor=BRD;e.currentTarget.style.color=DRK}}
          >Ingresar</button>
          <button className="cta" style={{padding:"10px 22px",fontSize:14}} onClick={()=>go("precios")}>Probá gratis</button>
        </div>
      </nav>

      {/* ── 1. HERO — atacar el dolor ── */}
      <section style={{paddingTop:72,minHeight:"78vh",background:`linear-gradient(155deg,#EEF2FF 0%,#F0FDF4 50%,#fff 100%)`,display:"flex",alignItems:"center"}}>
        <div style={{maxWidth:820,margin:"0 auto",padding:"48px 48px",textAlign:"center"}}>
          <div className="fu">
            {/* Pain statement */}
            <div style={{display:"inline-flex",alignItems:"center",gap:8,background:"#FEF3C7",border:"1px solid #FDE68A",borderRadius:20,padding:"6px 16px",marginBottom:28}}>
              <span style={{fontSize:14}}>⏱️</span>
              <span style={{fontSize:12,color:"#92400E",fontFamily:"monospace",fontWeight:700,letterSpacing:1}}>¿CUÁNTAS HORAS POR DÍA PERDÉS CONTESTANDO WHATSAPP DE TUS CLIENTES?</span>
            </div>

            <h1 style={{fontSize:58,fontWeight:700,color:DRK,lineHeight:1.06,letterSpacing:-2,marginBottom:22}}>
              Todavía no aplicaste<br/>
              <span style={{color:IND}}>IA en tu estudio contable.</span>
            </h1>

            <p style={{fontSize:19,color:MUT,lineHeight:1.75,marginBottom:12,maxWidth:600,margin:"0 auto 12px"}}>
              Optimizá la gestión de vencimientos, honorarios y conciliaciones de tus clientes con <strong style={{color:DRK,fontWeight:700}}>IA</strong>, todo desde WhatsApp y al alcance de tu mano.
            </p>
            <p style={{fontSize:14,color:GRN,fontWeight:700,letterSpacing:.5,marginBottom:40}}>
              Conectado a ARCA, ARBA y AGIP
            </p>

            <div style={{display:"flex",gap:14,justifyContent:"center",alignItems:"center",flexWrap:"wrap",marginBottom:24}}>
              <button className="cta cta-lg" onClick={()=>go("precios")}>
                Empezar gratis — 7 días →
              </button>
              <button onClick={()=>go("como")} style={{background:"none",border:"none",color:MUT,fontSize:15,cursor:"pointer",fontFamily:"inherit",fontWeight:500,textDecoration:"underline",textUnderlineOffset:3}}>
                ¿Cómo funciona?
              </button>
            </div>

            <p style={{fontSize:13,color:"#9CA3AF"}}>Sin tarjeta de crédito · Cancelás cuando querés</p>
          </div>
        </div>
      </section>

      {/* ── 2. PRECIOS ── */}
      <section id="precios" style={{padding:"52px 48px 88px",background:"#fff"}}>
        <div style={{maxWidth:1020,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:48}}>
            <h2 style={{fontSize:38,fontWeight:700,color:DRK,marginBottom:12}}>Simple. Sin sorpresas.</h2>
            <p style={{fontSize:16,color:MUT,marginBottom:24}}>Elegí tu plan y empezá a usar Gestia hoy. 7 días gratis en todos los planes pagos.</p>
            <div style={{display:"inline-flex",background:LGT,borderRadius:24,padding:"4px 5px",border:`1px solid ${BRD}`}}>
              {[["Anual  −30%",true],["Mensual",false]].map(([l,v])=>(
                <button key={String(v)} onClick={()=>setAnnual(v)} style={{padding:"8px 20px",borderRadius:20,border:"none",cursor:"pointer",fontSize:13,fontWeight:600,fontFamily:"inherit",background:annual===v?"white":"transparent",color:annual===v?DRK:MUT,boxShadow:annual===v?"0 1px 4px rgba(0,0,0,.1)":"none",transition:"all .2s"}}>{l}</button>
              ))}
            </div>
          </div>

          {/* MOBILE — tarjetas apiladas */}
          <style>{`
            .planes-mobile{display:none}
            .planes-desktop{display:block}
            @media(max-width:768px){
              .planes-mobile{display:flex;flex-direction:column;gap:16px}
              .planes-desktop{display:none}
            }
          `}</style>

          {/* MOBILE CARDS */}
          <div className="planes-mobile">
            {[
              {n:"Gratis", p:0, sub:"1 cliente", c:"#6B7280", hi:false, soporte:"—"},
              {n:"Starter", p:56000, sub:"Hasta 10 clientes", c:GRN, hi:false, soporte:"Email"},
              {n:"Estudio", p:105000, sub:"Hasta 30 clientes", c:IND, hi:true, soporte:"Email"},
              {n:"Pro", p:182000, sub:"+ 30 clientes", c:GRN, hi:false, soporte:"Email + WhatsApp"},
            ].map((p,i)=> <PlanCard key={i} p={p} i={i} annual={annual} IND={IND} GRN={GRN} DRK={DRK} MUT={MUT} BRD={BRD}/>)}
          </div>

          {/* DESKTOP TABLE */}
          <div className="planes-desktop">
            <table style={{width:"100%",borderCollapse:"collapse",tableLayout:"fixed"}}>
              <colgroup>
                <col style={{width:"20%"}}/>
                <col style={{width:"13%"}}/>
                <col style={{width:"22%"}}/>
                <col style={{width:"22%"}}/>
                <col style={{width:"23%"}}/>
              </colgroup>
              <thead>
                <tr>
                  <th style={{padding:"0 0 32px",textAlign:"left",verticalAlign:"bottom"}}>
                    <div style={{fontSize:13,color:MUT,fontWeight:400}}>Compará los planes</div>
                  </th>
                  {[
                    {n:"Gratis", p:0, sub:"1 cliente", c:"#6B7280", hi:false},
                    {n:"Starter", p:56000, sub:"Hasta 10 clientes", c:GRN, hi:false},
                    {n:"Estudio", p:105000, sub:"Hasta 30 clientes", c:IND, hi:true},
                    {n:"Pro", p:182000, sub:"+ 30 clientes", c:GRN, hi:false},
                  ].map((p,i)=>(
                    <th key={i} style={{padding:"0 10px 32px",textAlign:"center",verticalAlign:"bottom",position:"relative"}}>
                      {p.hi && <div style={{position:"absolute",top:-14,left:"50%",transform:"translateX(-50%)",background:IND,color:"white",fontSize:9,fontWeight:700,letterSpacing:2,padding:"3px 12px",borderRadius:20,whiteSpace:"nowrap"}}>⭐ MÁS ELEGIDO</div>}
                      <div style={{background:p.hi?"#EEF2FF":LGT,border:`2px solid ${p.hi?IND:BRD}`,borderRadius:12,padding:"22px 14px"}}>
                        <div style={{fontSize:12,fontWeight:700,color:p.c,textTransform:"uppercase",letterSpacing:1.5,marginBottom:14}}>{p.n}</div>
                        {p.p>0&&annual&&<div style={{fontSize:10,fontWeight:700,color:GRN,background:"#ECFDF5",border:"1px solid rgba(5,150,105,.2)",borderRadius:20,padding:"2px 10px",display:"inline-block",marginBottom:8}}>30% OFF</div>}
                        {p.p>0&&!annual&&<div style={{fontSize:10,color:"transparent",marginBottom:8}}>·</div>}
                        <div style={{marginBottom:10}}>
                          {p.p===0
                            ?<><span style={{fontSize:34,fontWeight:900,color:DRK,lineHeight:1}}>$0</span><div style={{fontSize:11,color:MUT,marginTop:3}}>/mes</div></>
                            :<>
                              <span style={{fontSize:34,fontWeight:900,color:p.hi?IND:DRK,lineHeight:1}}>${Math.round(annual?p.p*.7:p.p).toLocaleString("es-AR")}</span>
                              <div style={{fontSize:11,color:MUT,marginTop:3}}>/mes</div>
                              <div style={{fontSize:10,color:"#9CA3AF",marginTop:5}}>{annual?`$${Math.round(p.p*.7*12).toLocaleString("es-AR")} / año`:""}</div>
                            </>
                          }
                        </div>
                        <button onClick={()=>window.open("https://somosgestia.com/registro","_blank")}
                          style={{width:"100%",background:p.hi?IND:p.p===0?"#6B7280":DRK,color:"white",border:"none",borderRadius:7,padding:"10px 0",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"inherit",marginTop:4}}
                          onMouseEnter={e=>e.currentTarget.style.opacity=".85"}
                          onMouseLeave={e=>e.currentTarget.style.opacity="1"}
                        >{p.p===0?"Gratis":"Probá 7 días"}</button>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  {label:"Cantidad de clientes",            vals:["1","Hasta 10","Hasta 30","Ilimitados"]},
                  {label:"Cantidad de usuarios del estudio",vals:["1","2","3","5"]},
                  {label:"WhatsApp",                        vals:[true,true,true,true]},
                  {label:"Calendario de vencimientos",      vals:[true,true,true,true]},
                  {label:"Gestión de vencimientos",         vals:[true,true,true,true]},
                  {label:"Envío de honorarios",             vals:[true,true,true,true]},
                  {label:"Conciliación de facturas",        vals:[true,true,true,true]},
                  {label:"Consultas habituales de ARCA",    vals:[true,true,true,true]},
                  {label:"Recomendaciones de IA",           vals:[true,true,true,true]},
                  {label:"Soporte",                         vals:["—","Email","Email","Email + WhatsApp"]},
                ].map((row,ri)=>(
                  <tr key={ri} style={{borderTop:`1px solid ${BRD}`,background:ri%2===0?"transparent":"#FAFAFA"}}>
                    <td style={{padding:"9px 0",fontSize:11,color:MUT,fontWeight:400}}>{row.label}</td>
                    {row.vals.map((val,vi)=>(
                      <td key={vi} style={{padding:"9px 12px",textAlign:"center"}}>
                        {val===true?<span style={{color:GRN,fontSize:16}}>✓</span>
                         :val===false?<span style={{color:"#D1D5DB",fontSize:16}}>—</span>
                         :<span style={{fontSize:12,color:DRK,fontWeight:500}}>{val}</span>}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p style={{textAlign:"center",marginTop:24,fontSize:13,color:MUT}}>
            Precios en ARS · IVA no incluido · Sin permanencia mínima
          </p>
        </div>
      </section>

      {/* ── 3. STATS — 3 métricas creíbles ── */}
      <div style={{background:DRK,padding:"20px 48px"}}>
        <div style={{maxWidth:820,margin:"0 auto"}} className="stats-bar">
          {[["2 hs","recuperadas por día"],["90%","sin intervención tuya"],["24/7","atención automática"]].map(([v,l],i)=>(
            <div key={l} style={{padding:"0 40px",borderRight:i<2?"1px solid rgba(255,255,255,.1)":"none",textAlign:"center"}}>
              <span style={{fontSize:22,fontWeight:700,color:"#6EE7B7"}}>{v}</span>
              <span style={{fontSize:13,color:"#6B7280",marginLeft:8}}>{l}</span>
            </div>
          ))}
        </div>
      </div>

      {/* ── 4. FUNCIONALIDADES ── */}
      <section id="feat" style={{padding:"88px 48px",background:LGT}}>
        <div style={{maxWidth:1020,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:52}}>
            <div style={{fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:3,color:IND,textTransform:"uppercase",marginBottom:12}}>Funcionalidades</div>
            <h2 style={{fontSize:36,fontWeight:700,color:DRK,marginBottom:14}}>Como tener una asistente en tu estudio.</h2>
            <p style={{fontSize:16,color:MUT,maxWidth:580,margin:"0 auto",lineHeight:1.8}}>
              <span style={{fontFamily:"'Palatino Linotype','Book Antiqua',Georgia,serif",fontWeight:300,color:"#111827",letterSpacing:"-0.5px"}}>Gest</span><span style={{display:"inline-block",width:"1.5px",height:"0.9em",background:"#B0B8C4",margin:"0 3px",verticalAlign:"middle"}}></span><span style={{fontFamily:"'Palatino Linotype','Book Antiqua',Georgia,serif",fontWeight:700,color:IND,letterSpacing:"-0.5px"}}>IA</span>
              {" "}mira ARCA, revisa los documentos que mandan tus clientes, vela por los honorarios del estudio, avisa de todo lo que necesitan y responde lo que sabe. Lo que no, te lo deriva a vos con el contexto completo. Como una asistente que nunca descansa.
            </p>
          </div>
          <div className="feats-grid">
            {FEATS.map((f,i)=>(
              <div key={i} className="fc">
                <div style={{fontSize:26,marginBottom:12}}>{f.e}</div>
                <h3 style={{fontSize:15,fontWeight:700,color:DRK,marginBottom:7}}>{f.t}</h3>
                <p style={{fontSize:13,color:MUT,lineHeight:1.75}}>{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 5. CÓMO FUNCIONA ── */}
      <section id="como" style={{padding:"88px 48px",background:"#fff"}}>
        <div style={{maxWidth:860,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:52}}>
            <div style={{fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:3,color:GRN,textTransform:"uppercase",marginBottom:12}}>Cómo funciona</div>
            <h2 style={{fontSize:36,fontWeight:700,color:DRK,marginBottom:12}}>En marcha en menos de 10 minutos</h2>
            <p style={{fontSize:16,color:MUT,maxWidth:420,margin:"0 auto"}}>Sin desarrollo. Sin integraciones complejas. Sin cambiar cómo trabajás.</p>
          </div>
          <div className="steps-grid" style={{marginBottom:52}}>
            {[
              {n:"01",e:"🔌",t:"Conectás con ARCA",d:"Ponés el link del drive donde tengas la información, subís un Excel o CSV, o directamente lo cargás a mano — como prefieras."},
              {n:"02",e:"⚙️",t:"Configurás el asistente",d:"Le ponés el nombre de tu estudio, foto y le decís lo que querés que haga: vencimientos, avisos, honorarios, etc."},
              {n:"03",e:"✅",t:"¡Listo!",d:"Vos solo atendés lo importante. El asistente escala lo que requiere tu criterio profesional."},
            ].map((s,i)=>(
              <div key={i} style={{textAlign:"center"}}>
                <div style={{position:"relative",display:"inline-block",marginBottom:16}}>
                  <div style={{width:56,height:56,borderRadius:"50%",background:"#EEF2FF",border:`2px solid ${IND}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24}}>{s.e}</div>
                  <div style={{position:"absolute",top:-8,right:-8,width:22,height:22,borderRadius:"50%",background:IND,color:"#fff",fontSize:10,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"monospace"}}>{s.n}</div>
                </div>
                <h4 style={{fontSize:14,fontWeight:700,color:DRK,marginBottom:8}}>{s.t}</h4>
                <p style={{fontSize:13,color:MUT,lineHeight:1.65}}>{s.d}</p>
              </div>
            ))}
          </div>
          {/* Video placeholder */}
          <div style={{background:"linear-gradient(135deg,#1E1B4B,#065F46)",borderRadius:16,padding:"56px 32px",textAlign:"center",cursor:"pointer"}}
            onMouseEnter={e=>e.currentTarget.style.opacity=".9"}
            onMouseLeave={e=>e.currentTarget.style.opacity="1"}
          >
            <div style={{width:64,height:64,borderRadius:"50%",background:"rgba(255,255,255,.15)",border:"2px solid rgba(255,255,255,.3)",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px",transition:"transform .2s"}}
              onMouseEnter={e=>e.currentTarget.style.transform="scale(1.1)"}
              onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>
            </div>
            <div style={{fontSize:18,color:"white",fontWeight:700,marginBottom:6}}>Demo completo — 3 minutos</div>
            <div style={{fontSize:14,color:"rgba(255,255,255,.55)"}}>Cómo el agente atiende, gestiona vencimientos y alerta al contador</div>
          </div>
        </div>
      </section>

      {/* ── 6. TESTIMONIAL ── */}
      <div style={{background:IND,padding:"64px 48px"}}>
        <div style={{maxWidth:680,margin:"0 auto",textAlign:"center"}}>
          <div style={{fontSize:56,color:"rgba(255,255,255,.15)",lineHeight:1,marginBottom:16,fontFamily:"Georgia,serif"}}>"</div>
          <p style={{fontSize:22,color:"white",lineHeight:1.75,fontStyle:"italic",marginBottom:28}}>
            Hay días que no pude trabajar dos horas seguidas sin que me interrumpan. Con Gestia, mis clientes tienen respuesta al instante y yo puedo concentrarme en lo que realmente importa.
          </p>
          <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:12}}>
            <div style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:700,color:"white"}}>MG</div>
            <div style={{textAlign:"left"}}>
              <div style={{fontSize:15,fontWeight:700,color:"white"}}>Marcelo G. — Contador Público</div>
              <div style={{fontSize:13,color:"rgba(255,255,255,.6)"}}>Caballito, CABA · 47 clientes activos</div>
            </div>
          </div>
        </div>
      </div>

      {/* ── 7. FAQ ── */}
      <section id="faq" style={{padding:"88px 48px",background:LGT}}>
        <div style={{maxWidth:660,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:48}}>
            <div style={{fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:3,color:GRN,textTransform:"uppercase",marginBottom:12}}>FAQ</div>
            <h2 style={{fontSize:34,fontWeight:700,color:DRK}}>Preguntas frecuentes</h2>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {FAQS.map((f,i)=>(
              <div key={i} className="fq" onClick={()=>setFaq(faq===i?null:i)}>
                <div style={{padding:"16px 22px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span style={{fontSize:15,fontWeight:600,color:DRK,lineHeight:1.4}}>{f.q}</span>
                  <div style={{width:28,height:28,borderRadius:"50%",background:faq===i?IND:"#EEF2FF",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,marginLeft:16,transition:"all .18s"}}>
                    <span style={{color:faq===i?"white":IND,fontSize:18,lineHeight:1,display:"block",transform:faq===i?"rotate(45deg)":"none",transition:"transform .18s"}}>+</span>
                  </div>
                </div>
                {faq===i&&<div style={{padding:"0 22px 18px",fontSize:14,color:MUT,lineHeight:1.8}}>{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 8. CONTACTO — para quien todavía tiene dudas ── */}
      <section id="contacto" style={{padding:"88px 48px",background:"#fff"}}>
        <div style={{maxWidth:860,margin:"0 auto"}} className="contact-grid">
          <div>
            <div style={{fontSize:11,fontFamily:"monospace",fontWeight:700,letterSpacing:3,color:IND,textTransform:"uppercase",marginBottom:12}}>¿Tenés dudas?</div>
            <h2 style={{fontSize:34,fontWeight:700,color:DRK,lineHeight:1.2,marginBottom:14}}>Hablemos antes de que empieces.</h2>
            <p style={{fontSize:16,color:MUT,lineHeight:1.8,marginBottom:28}}>
              Si tenés alguna consulta antes de arrancar, escribinos. Respondemos en menos de 24 horas.
            </p>
            <div style={{display:"flex",flexDirection:"column",gap:14}}>
              {[["✉️","hola@somosgestia.com"],["📱","WhatsApp directo"],["📍","Buenos Aires, Argentina"]].map(([e,t])=>(
                <div key={t} style={{display:"flex",gap:12,alignItems:"center"}}>
                  <div style={{width:38,height:38,borderRadius:10,background:"#EEF2FF",display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>{e}</div>
                  <span style={{fontSize:14,color:"#374151"}}>{t}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{background:LGT,borderRadius:16,padding:"32px 28px",border:`1.5px solid ${BRD}`}}>
            {sent?(
              <div style={{textAlign:"center",padding:"24px 0"}}>
                <div style={{fontSize:48,marginBottom:14}}>✅</div>
                <h3 style={{fontSize:20,fontWeight:700,color:DRK,marginBottom:8}}>¡Mensaje recibido!</h3>
                <p style={{fontSize:14,color:MUT,lineHeight:1.7}}>Te respondemos en menos de 24 horas.</p>
              </div>
            ):(
              <>
                <h3 style={{fontSize:18,fontWeight:700,color:DRK,marginBottom:20}}>Mandanos tu consulta</h3>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <input className="inp" placeholder="Tu nombre" value={form.nombre} onChange={e=>setForm(p=>({...p,nombre:e.target.value}))}/>
                  <input className="inp" type="email" placeholder="Tu email" value={form.email} onChange={e=>setForm(p=>({...p,email:e.target.value}))}/>
                  <input className="inp" type="tel" placeholder="WhatsApp (opcional)" value={form.tel} onChange={e=>setForm(p=>({...p,tel:e.target.value}))}/>
                  <textarea className="inp" placeholder="¿En qué te podemos ayudar?" rows={4} value={form.consulta} onChange={e=>setForm(p=>({...p,consulta:e.target.value}))} style={{resize:"vertical"}}/>
                  <button className="cta" style={{width:"100%",padding:"13px"}} onClick={()=>{if(form.nombre&&form.email)setSent(true);}}>
                    Enviar consulta →
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section style={{padding:"88px 48px",background:`linear-gradient(135deg,#EEF2FF,#F0FDF4)`}}>
        <div style={{maxWidth:560,margin:"0 auto",textAlign:"center"}}>
          <div style={{display:"flex",justifyContent:"center",marginBottom:24}}>
            <GestiaLogo height={58}/>
          </div>
          <h2 style={{fontSize:40,fontWeight:700,color:DRK,lineHeight:1.12,marginBottom:14}}>
            Probalo gratis.<br/><span style={{color:IND}}>7 días, sin riesgo.</span>
          </h2>
          <p style={{fontSize:16,color:MUT,lineHeight:1.7,marginBottom:32}}>
            Si en 7 días no recuperaste tu tiempo, podés cancelar sin ningún trámite.
          </p>
          <button className="cta cta-lg" onClick={()=>window.open("https://somosgestia.com/registro","_blank")}>
            Empezar gratis →
          </button>
          <p style={{marginTop:14,fontSize:13,color:MUT}}>Sin tarjeta · Sin permanencia · Cancelás cuando querés</p>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer style={{background:DRK,padding:"40px 48px"}}>
        <div style={{maxWidth:1060,margin:"0 auto"}}>
          <div className="footer-grid" style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:28,paddingBottom:28,borderBottom:"1px solid rgba(255,255,255,.08)"}}>
            <GestiaLogo height={46} dark/>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              {[["Precios","precios"],["Funcionalidades","feat"],["Cómo funciona","como"],["FAQ","faq"],["Contacto","contacto"]].map(([l,id])=>(
                <button key={id} onClick={()=>go(id)} style={{background:"none",border:"none",fontFamily:"inherit",fontSize:13,color:"#6B7280",cursor:"pointer",padding:"4px 10px",borderRadius:6,transition:"color .14s"}}
                  onMouseEnter={e=>e.target.style.color="#E5E7EB"}
                  onMouseLeave={e=>e.target.style.color="#6B7280"}
                >{l}</button>
              ))}
            </div>
          </div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{fontSize:12,color:"#4B5563",fontFamily:"monospace"}}>© 2026 somosgestia.com</div>
            <div style={{display:"flex",gap:20}}>
              {["Términos y condiciones","Política de privacidad"].map(t=>(
                <a key={t} href="#" style={{fontSize:12,color:"#4B5563",textDecoration:"none"}}
                  onMouseEnter={e=>e.target.style.color="#9CA3AF"}
                  onMouseLeave={e=>e.target.style.color="#4B5563"}
                >{t}</a>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
